import { EditNoteOutlined } from '@mui/icons-material';
import { Box, IconButton, Tooltip } from '@mui/material';
const columnShape = [
    {
        Header: 'No',
        accessor: 'number',
        maxWidth: 60,
        Cell: ({ row }) => {
            return <Box>{row.original.number || '-'}</Box>;
        },
    },
    {
        Header: 'Title',
        accessor: 'title',
        minWidth: 600,
    },
    {
        Header: 'Score',
        accessor: 'score',
    },
    {
        Header: 'Action',
        accessor: 'id',
        maxWidth: 20,
        Cell: ({ row, handleScoring }) => {
            return (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <Tooltip title="Edit Score">
                        <IconButton
                            onClick={() => handleScoring(row.original)}
                            sx={{
                                color: 'text.disabled',
                                fontSize: 18,
                            }}
                        >
                            <EditNoteOutlined />
                        </IconButton>
                    </Tooltip>
                </Box>
            );
        },
    },
];
export default columnShape;
